// Opens Crisp chat prefilled with a message. Crisp is not loaded for Free
// sellers (and can be blocked by the browser), so fall back to a support email
// draft instead of silently doing nothing.
export default function contactSupport(message) {
  if (window.$crisp) {
    window.$crisp.push(['set', 'message:text', [message]]);
    window.setTimeout(() => {
      window.$crisp.push(['do', 'chat:open']);
    }, 300);
    return;
  }

  window.location.href = `mailto:support@checkoutpage.com?body=${encodeURIComponent(message)}`;
}
